import React, { useRef, useContext } from "react";
import { ViewContext } from "venuescanner-js/react/components/Inbox/context/ViewContext";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

const commonSearchButtonStyles = {
  color: "gray800",
  height: "32px",
  width: "32px",
};

const Search = () => {
  const { setChatFilter, isSearchActive, setIsSearchActive } =
    useContext(ViewContext);
  const inputRef = useRef(null);

  const toggleSearch = (bool) => {
    if (bool) {
      inputRef.current.focus();
    } else {
      inputRef.current.value = "";
      setChatFilter(null);
    }
    setIsSearchActive(bool);
  };

  const toggleSearchButton = () => {
    if (isSearchActive) {
      return (
        <IconButton
          onClick={() => toggleSearch(false)}
          sx={{
            ...commonSearchButtonStyles,
          }}
        >
          <CloseIcon
            sx={{
              fontSize: 18,
            }}
          />
        </IconButton>
      );
    }

    return (
      <IconButton
        onClick={() => toggleSearch(true)}
        variant="outlined"
        sx={{
          ...commonSearchButtonStyles,
          border: 1,
          borderRadius: "50%",
          borderColor: "gray800",
        }}
      >
        <SearchIcon />
      </IconButton>
    );
  };

  return (
    <div
      className={`chat-search ${isSearchActive ? "isActive" : "isInactive"}`}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          setChatFilter(e.target[0].value);
        }}
        className={isSearchActive ? "active" : ""}
      >
        <input name="search" ref={inputRef} />
      </form>
      <div
        className={`chat-search-icon${
          isSearchActive ? " chat-search-icon-active" : ""
        }`}
      >
        {toggleSearchButton()}
      </div>
    </div>
  );
};

export default Search;
